import UpdateAdmin from './UpdateAdmin';
export default UpdateAdmin;
